interface LinkItemProps {
  title: string;
  description: string;
  url: string;
  icon: JSX.Element;
}

const LinkItem: React.FC<LinkItemProps> = ({
  title,
  description,
  url,
  icon,
}) => {
  return (
    <a
      href={url}
      className="billing-link-item"
      target="_blank"
      rel="noreferrer noopener"
    >
      <span className="billing-link-item-icon">{icon}</span>
      <span>
        <h6>{title}</h6>
        <p>{description}</p>
      </span>
    </a>
  );
};

export { LinkItem };
